import React from 'react';
import './sideBar.scss'
import SessionCache from '../../home/components/routes/session-cache';
import Services from '../../service/service';
import Path from '../../home/components/routes/routes-path';
import { getImageSource } from '../../home/utility/image-source';
import { Constants, ImageConstants } from '../../home/constants/constants';
import CommonUtils from '../../home/utility/common-utilities';

export default class SideBar extends React.Component {
    state = {
        user: {},
        activeIndex: 0,
        showSubMenuList: [],
        reload: true
    }
    constructor(props) {
        super(props)

        console.log(this.props.routes)

        this.state.routes = this.props.routes

        // CLASS_WORKS, CLICKER_PRACTICE - is for Clicker Practice Offline Flow

        let user = SessionCache.getUser()

        if(user.subjectId === Constants.SCIENCE_SUBJECTID && !Constants.ELECTRON_BUILD) {
            this.state.routes = this.props.routes.filter(item => (item.moduleName === 'DASHBOARD' ||
                item.moduleName === 'CLASS_WORKS'||
                item.moduleName === 'PERSONALISED_CLASS_WORK'||
                item.moduleName === 'SETUP' ||
                item.moduleName === 'EDIT_TEACHER_PROFILE'||
                item.moduleName === 'PROFILE' ||
                item.moduleName === 'MERIT_LEADERBOARD' ||
                item.moduleName === 'STUDENT_ENGAGEMENT_REPORT'
            ))
        }


        if (!CommonUtils.isOnline()) {
            this.state.routes = this.props.routes.filter(item => (item.moduleName === 'JIGYASA_ASSESSMENT' ||
                item.moduleName === 'CLICKER_QUIZ' ||
                item.moduleName === 'CLICKER_PRACTICE' || item.moduleName === 'CLASS_WORKS' || item.moduleName === 'CLICKER_ASSESSMENT'))
        }

        

        console.log(this.state.routes)


        if (this.props.location.pathname) {
            let pathIndex = 0

            for (let i = 0; i < this.props.routes.length; i++) {

                if (this.props.location.pathname == this.props.routes[i].path) {
                    pathIndex = i
                    break
                }
            }

            this.state.activeIndex = pathIndex
        }

        this.state.showSubMenuList = []
        Services.setSideMenu(this)
    }

    componentDidMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            if (this.props.routes && this.props.routes.length) {
                let idx = this.props.routes.findIndex(r => r.path === location.pathname);
                if (idx > -1) this.setState({ activeIndex: idx })
            }
        });
        this.checkUserAccess()
        // this.onClickRoutes(0, this.props.routes[0])
    }

    componentWillUnmount() {
        this.unlisten();
    }

    checkUserAccess() {

        let user = SessionCache.getUser()

        console.log(user)

        let schoolProfileConfirmed = user.schoolInfo?.isConfirmed
        let totalSections = user.schoolInfo?.totalSections
        let enableAll = false
        if (schoolProfileConfirmed && totalSections) {
            enableAll = true
        }
        this.setState({ user, enableAll })
    }

    onClickRoutes = (index, route, sIndex) => {
        console.log(route)
        if (route && route.path) {
            if (!route.disabled || this.state.enableAll) {
                if (!route.subMenus) {
                    this.props.history.push(route.path)
                    this.setState({ activeIndex: index })
                    this.setState({ activeSubMenuIndex: sIndex })
                }

            }
        }
    }

    refreshSideMenu = () => {
        this.checkUserAccess()
    }


    showSubMenuList(index) {
        let showSubMenuList = this.state.showSubMenuList
        console.log(showSubMenuList)
        this.state.routes.forEach((route, idx) => {
            if (idx !== index) {
                showSubMenuList[idx] = false
            }
        })
        showSubMenuList[index] = showSubMenuList[index] ? false : true

        console.log(index, showSubMenuList)

        this.setState({ showSubMenuList, selectedIndex: index, reload: false }, () => {
            this.setState({ reload: true })
        })
    }

    render() {
        const pathName = this.props.location?.pathname
        return (
            <div className='side-bar-v3'>
                <div className='container'>

                    <div className='profile-container' onClick={() => this.props.history.push({ pathname: Path.EDIT_TEACHER_PROFILE })}>
                        <div className='profile-image-wrapper'><div className='profile-image'>
                            {
                                this.state.user?.image && this.state.user.basePath ? <img src={this.state.user.basePath + this.state?.user?.image} className='profile-image-size' />
                                    :
                                    <img src={'https://cfr.annauniv.edu/research/images/anna.png'} className='profile-image-size' />
                            }

                        </div></div>
                        <div className='profile-title pt-2 text-center'>
                            {this.state?.user?.name || ""}
                        </div>
                    </div>


                    <div className='routes-container' id="scroll-1">

                        {/* <div className={`route-wrapper`}>
                            <div className='route-title-wrapper'><span className='route-title'></span></div>
                        </div> */}

                        {this.state.routes && this.state.routes.length && this.state.routes.map((route, index) => (
                            <>
                                {
                                    route.notShowInSideBar ?
                                        <></>
                                        :
                                        <div key={route.title} className={`menu-container`}>
                                            <div className={`cursor-pointer menu-border ${pathName === route.path ? '' : ''}`}
                                            >
                                                <div className={`route-wrapper ${pathName === route.path ? 'active-menu' : ''} ${route.subMenus?.length > 0 ? "has-submenu" : ""}`}
                                                    onClick={() => {
                                                        this.onClickRoutes(index, route)
                                                        this.showSubMenuList(index)
                                                    }}>
                                                    {/* <img className='route-icon' src={index == this.state.activeIndex ? route.activeIcon : route.inActiveIcon} /> */}
                                                    <div className='route-title-wrapper d-flex justify-content-between align-items-center'>
                                                        <span className={`route-title  ${route.disabled && !this.state.enableAll ? "route-title-disabled" : ""}`}>{route.title}</span>
                                                        {
                                                            route.subMenus && <img className='white-wrrow' src={getImageSource(this.state.showSubMenuList[index]
                                                                && this.state.selectedIndex === index ? ImageConstants.WHITE_UP_ANGLE_ARROW : ImageConstants.WHITE_DOWN_ANGLE_ARROW)} />
                                                        }
                                                    </div>
                                                    <div className='route-sub-title-wrapper'><span className={`route-sub-title`}>{route.subTitle}</span></div>
                                                </div>
                                            </div>
                                            {this.state.showSubMenuList[index]
                                                && this.state.selectedIndex === index ?
                                                <>
                                                    <div className=''>
                                                        {route.subMenus && route.subMenus.map((sRoute, sIndex) => (
                                                            <div
                                                                key={sRoute.title}
                                                                className={`cursor-pointer menu-border  ${pathName === sRoute.path ? 'active-menu-bg' : ''}`}
                                                                onClick={() => this.onClickRoutes(index, sRoute, sIndex)}
                                                            >
                                                                <div
                                                                    className={`route-sub-menu-bg   ${sRoute.disabled && !this.state.enableAll
                                                                        ? 'route-wrapper-disabled'
                                                                        : ''}
                                                                            ${pathName === sRoute.path
                                                                            ? 'active-menu'
                                                                            : ''
                                                                        }
                                                                            ${sIndex == sRoute.subMenus?.length - 1 &&
                                                                            this.state.activeSubMenuIndex !=
                                                                            sRoute.subMenus?.length - 1
                                                                            ? ' padding-bottom-for-last-child'
                                                                            : ''
                                                                        }`}
                                                                >
                                                                    <div className='route-title-wrapper'>
                                                                        <span
                                                                            className={`route-title  ${sRoute.disabled && !this.state.enableAll
                                                                                ? 'route-title-disabled'
                                                                                : ''
                                                                                }`}
                                                                        >
                                                                            {sRoute.title}
                                                                        </span>
                                                                    </div>
                                                                    <div className='route-sub-title-wrapper'>
                                                                        <span
                                                                            className={`route-sub-title`}
                                                                        >
                                                                            {sRoute.subTitle}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>

                                                :
                                                <></>

                                            }


                                        </div>

                                }
                            </>

                        ))}

                        {this.state.activeIndex == this.props.routes.length - 1 ? <div className={`route-wrapper padding-bottom-for-last-child`}>
                            <div className='route-title-wrapper'><span className='route-title'></span></div>
                        </div> : <></>}

                    </div>

                </div>
            </div >
        )
    }
}